import * as React from "react"
import { Appearance, ImageStyle, TextStyle, ViewStyle } from "react-native"
import { observer } from "mobx-react-lite"
import { color, images } from "../../theme"
import { Text } from "../text/text"
import { AutoImage } from "../auto-image/auto-image"
import { Button } from "../button/button"
import { View } from "native-base"

const INSIDE: ViewStyle = {
  borderRadius: 10,
  borderWidth: 1,
  borderColor: color.palette.gray200,
  paddingVertical: 16,
  paddingHorizontal: 16,
  flexDirection: 'row',
  alignItems: 'center'
}

const LEFT: ViewStyle = {
  flex: 3,
  paddingRight: 16
}

const RIGHT: ViewStyle = {
  flex: 2,
  justifyContent: 'center',
  alignItems: 'center'
}

const SUBTITLE: TextStyle = {
  marginTop: 4,
  marginBottom: 8
}

const IMAGE: ImageStyle = {
  resizeMode: 'contain',
  width: 130,
  height: 100
}

export interface ConsultCardProps {
  /**
   * An optional style override useful for padding & margin.
   */
  // style?: StyleProp<ViewStyle>
  colorScheme?: "light" | "dark",
  onPress?:  () => void
}

/**
 * Describe your component here
 */
export const ConsultCard = observer(function ConsultCard(props: ConsultCardProps) {
  const { colorScheme = "light" || Appearance.getColorScheme(), onPress } = props

  return <View style={INSIDE}>
    <View style={LEFT}>
      <Text tx="homeScreen.consultTitle" preset="title3" colorScheme={colorScheme} />
      <Text style={SUBTITLE} tx="homeScreen.consultSubtitle" preset="body3" colorScheme={colorScheme} />
      <Button
        testID="jala:id/consult-button"
        tx="homeScreen.consultButton"
        textPreset="title5"
        colorScheme={colorScheme}
        onPress={onPress}
      />
    </View>
    <View style={RIGHT}>
      <AutoImage source={images.consult} style={IMAGE} />
    </View>
  </View>
})
